import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_APPOINTMENT_REQUEST = NS + 'FIND_APPOINTMENT_REQUEST'
export const FIND_APPOINTMENT_SUCCESS = NS + 'FIND_APPOINTMENT_SUCCESS'
export const FIND_APPOINTMENT_ERROR = NS + 'FIND_APPOINTMENT_ERROR'

export const CHANGE_APPOINTMENT = NS + 'CHANGE_APPOINTMENT'

export const SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST = NS + 'SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST'
export const SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS = NS + 'SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS'
export const SET_APPOINTMENT_CANCEL_CATEGORY_ERROR = NS + 'SET_APPOINTMENT_CANCEL_CATEGORY_ERROR'



// WEBPACK FOOTER //
// ./src/modules/appointment/state/detail/type.js